<template>
  <t-default-layout active-nav-id="campaigns">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="Campaigns" :show="show" />
      <form
        ref="form"
        class="t-campaigns-detail__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-campaigns-detail__fields">
          <m-section>
            <m-action-card :id="idName[0]" title="記事・セミナー登録" header-border no-header-margin icon="clock">
              <div class="t-campaigns-detail__fields__pushtype">
                <m-form-input id="t-campaigns-detail-info-importantFlag__form-input">
                  <a-text id="t-campaigns-detail__fields__a-text-top_1">●</a-text>
                  <a-text id="t-campaigns-detail-info-importantFlag__a-text">PICKUP</a-text>
                  <a-switch
                    id="t-campaigns-detail-importantFlag"
                    v-model="campaignData.importantFlag"
                    data-testid="detail-campaign-important-display"
                    :disabled="true"
                  />
                </m-form-input>
                <m-form-input id="t-campaigns-detail__fields__pushtype_1">
                  <a-text id="t-campaigns-detail__fields__a-text-top_2">●</a-text>
                  <a-text id="t-campaigns-detail__fields__pushtype__a-text">通知ステータス</a-text>
                  <a-select-field
                    id="t-campaigns-detail__fields__pushtype__a-select-field_1"
                    v-model="pushStatus"
                    :options="pushStatusOptions"
                    disabled="true"
                  />
                  <a-text id="t-campaigns-detail__fields__pushtype__pushDoneCount"
                    >プッシュ通知総回数: {{ campaignData.pushDoneCount }}回</a-text
                  >
                </m-form-input>
              </div>
              <div v-if="pushStatus !== 'none'" class="t-campaigns-detail__fields__pushcategory">
                <m-form-input id="t-campaigns-detail-info-pushcategory__form-input">
                  <a-text id="t-campaigns-detail__fields__pushcategory__a-text-top">●</a-text>
                  <a-text id="t-campaigns-detail__fields__pushcategory__a-text">プッシュ通知カテゴリ</a-text>
                  <div id="t-campaigns-detail__fields__pushcategory__a-apply-text-field">
                    <a-apply-text-field
                      id="t-campaigns-detail__fields__pushcategory__a-apply-text-field-id"
                      v-model="campaignData.pushCategory"
                      data-testid="detail-campaigns-pushcategory"
                      type="text"
                      maxlength="10"
                      disabled="true"
                      maxlength-id="t-campaigns-detail-pushcategory-count"
                    />
                  </div>
                </m-form-input>
              </div>
              <o-push-segment-type 
                v-if="pushStatus === 'limited'" 
                id="campaign-add-segment-type"
                v-model="campaignData.pushSegmentType"
                data-testid="add-campaign-segment-type"
                disabled="true"
              />

              <o-push-segment-selection
                v-if="pushStatus === 'limited' && campaignData.pushSegmentType === 'selection'"
                id="campaign-add-segment-selection"
                v-model="campaignData.pushSegmentSelectionInfo"
                data-testid="add-campaign-segment-selection"
                disabled="true"
              />

              <div
                v-if="pushStatus === 'limited' && campaignData.pushSegmentType === 'csv'"
                id="t-campaigns-detail__fields__csv-history" class="t-campaigns-detail__fields__csv-history">
                <a-text id="t-campaigns-detail__fields__a-text-top_3">●</a-text>
                <a-text id="t-campaigns-detail__fields__csv-history__a-text">CSVアップロード履歴</a-text>
                <o-csv-history :id="id" type="campaign" :csvlist="filteredSegmentCsvList" />
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="detail-campaign"
              title="内容サマリ"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-campaigns-detail__fields">
                <!-- category -->
                <div class="t-campaigns-detail__col-1">
                  <m-form-input id="-campaigns-detail__fields__category">
                    <div class="t-campaigns-detail__category">
                      <o-transition-type-category
                      v-model:transition-id="campaignData.categoryId"   
                      disabled="true"
                   />
                    </div>
                  </m-form-input>
                </div>
                <!-- end category -->
                <div id="t-campaigns-detail-uploading-file" class="t-campaigns-detail__row">
                  <div class="t-campaigns-detail__col-1">
                    <div class="t-campaigns-detail__fields">
                      <m-form-input>
                        <a-upload-field
                          id="t-campaigns-detail-upload-image"
                          v-model="campaignData.imageFile.file"
                          test-id-text="detail-campaign-summary-image"
                          name="imageFile"
                          class="t-campaigns-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-campaigns-detail__col-2">
                    <div class="t-campaigns-detail__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="campaignData.title"
                          data-testid="detail-campaign-summary-title-display"
                          type="text"
                          maxlength="16"
                          placeholder="タイトル入力"
                          :disabled="true"
                          maxlength-id="add-campaign-detail-title-maxlength"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-apply-text-field
                          v-model="campaignData.text"
                          data-testid="detail-campaign-summary-content-display"
                          class="t-campaigns-detail__content-input"
                          type="textarea"
                          rows="7"
                          maxlength="35"
                          placeholder="テキスト入力"
                          :disabled="true"
                          maxlength-id="add-campaign-detail-text-maxlength"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[2]" title="詳細ページ内容" header-border no-header-margin icon="clock-remove">
              <div class="t-campaigns-detail__fields">
                <div id="t-campaigns-detail-info-uploading-file" class="t-campaigns-detail__row">
                  <div class="t-campaigns-detail__col-1">
                    <div class="t-campaigns-detail__fields">
                      <m-form-input>
                        <a-upload-field
                          id="t-campaigns-detail-info-upload-image"
                          v-model="campaignData.detailInfo.imageFile.file"
                          test-id-text="detail-campaign-detail-image"
                          class="t-campaigns-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-campaigns-detail__col-2">
                    <div class="t-campaigns-detail__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="t-campaigns-detail-info-title"
                          v-model="campaignData.detailInfo.title"
                          data-testid="detail-campaign-detail-title-display"
                          type="text"
                          maxlength="50"
                          placeholder="タイトル入力"
                          :disabled="true"
                          maxlength-id="add-campaign-detail-info-maxlength"
                        />
                      </m-form-input>
                      <m-rich-text-editor
                        id="htmlContent"
                        :html-content="campaignData.detailInfo.htmlContent"
                        read-only="true"
                        max-length="800"
                      />
                    </div>
                  </div>
                </div>
                <o-transition-type-service
                  v-if="updatedDataFlag"
                  v-model:transition-type="campaignData.detailInfo.transitionType"
                  v-model:transition-doc="campaignData.detailInfo.transitionDoc"
                  v-model:contents-url="campaignData.detailInfo.contentsURL"
                  disabled="true"
                />
                <div v-if="campaignData.detailInfo.transitionType === 'url'" class="t-campaigns-detail__fields">
                  <m-form-input id="t-campaigns-detail-info-webviewFlag__form-input">
                    <a-text id="t-campaigns-detail-info-webviewFlag__a-text">Webビュー</a-text>　　
                    <a-switch
                      id="t-campaigns-detail-webviewFlag"
                      v-model="campaignData.detailInfo.webviewFlag"
                      data-testid="add-campaigns-detail-webview-toggle-button"
                      :disabled="true"
                    />
                    <a-text id="t-campaigns-detail-info-webview-note__a-text"
                      >※Webビュー設定ONの場合、URLにはダイナミックリンクを登録しないでください。</a-text
                    >
                  </m-form-input>
                </div>
                <div v-if="campaignData.detailInfo.transitionType === 'url'" class="t-campaignData-add__fields">
                  <m-form-input id="t-campaigns-detail-info-dAccountLoginFlag__form-input">
                    <a-text id="t-campaigns-detail-info-dAccountLoginFlag__a-text">ビジネスｄアカウントログイン</a-text>
                    <a-switch
                      id="t-campaigns-add-dAccountLoginFlag"
                      v-model="campaignData.detailInfo.dAccountLoginFlag"
                      data-testid="add-campaignData-detail-webview-toggle-button"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-campaigns-detail__fields">
                <div id="t-campaigns-detail-cast-start-date-day__row" class="t-campaigns-detail__row">
                  <a-text id="t-campaigns-detail-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-campaigns-detail-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="campaignData.castStartDate"
                      test-id-text="detail-campaign-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div class="t-campaigns-detail__row">
                  <a-text id="t-campaigns-detail-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-campaigns-detail-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="campaignData.castEndDate"
                      test-id-text="detail-campaign-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-campaigns-detail__fields__pushtype">
                <m-form-input id="t-campaigns-detail__fields__pushtype_2">
                  <a-select-field
                    id="t-campaigns-detail__fields__pushtype__a-select-field_2"
                    v-model="campaignData.checkStatus"
                    data-testid="detail-campaign-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="campaignData.checkHistories"
                id-text="campaign-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <div id="t-campaigns-test-buttons">
          <o-test-push-selected v-if="isManager" :id="id" type="campaign" :csvlist="filteredTestSegmentCsvList" />
          <o-test-push v-else :id="id" type="campaign" />
        </div>
        <div id="t-campaigns-detail-buttons">
          <div v-show="!isPublished" class="t-campaigns-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-campaigns-detail-detail-saveBtn"
                data-testid="detail-campaign-edit-button"
                variant="block"
                color="primary"
                :disabled="isEnded || disableButton"
                @click="handleNavigateEdit"
                >編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-campaigns-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-campaigns-detail-edit-return-unpublished-btn"
                data-testid="detail-campaign-edit-return-unpublished-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleEditReturnUnpublished"
                >未公開に戻す</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-campaigns-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-campaigns-detail-edit-keep-published-btn"
                data-testid="detail-campaign-edit-keep-published-button"
                variant="block"
                color="primary"
                :disabled="disabledButton || disableButton"
                @click.stop="handleEditKeepPublished"
                >公開のまま編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div class="t-campaigns-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-campaigns-detail-detail-deleteBtn"
                data-testid="detail-campaign-delete-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleConfirmDelete"
                >削除</a-button
              >
            </m-form-action-buttons>
          </div>
        </div>
      </form>
    </div>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="campaignsCreate_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="campaignsCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="t-campaigns-remove-modal-close-button"
            data-testid="detail-campaign-modal-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="t-campaigns-delete-button"
            data-testid="detail-campaign-modal-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleDelete"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import OTransitionTypeService from '@/components/organisms/transition-type-service';
import OTransitionTypeCategory from '@/components/organisms/transition-type-category';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import dayjs from 'dayjs';
import MRichTextEditor from '@/components/molecules/rich-text-editor';
import OPushSegmentType from '@/components/organisms/push-segment-type';
import OPushSegmentSelection from '@/components/organisms/push-segment-selection';
import { buildPushSegmentSelectionForDisplay } from '@/common/pushSegmentConvert';

export default {
  name: 't-campaigns-detail',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    AApplyTextField,
    MRichTextEditor,
    OTransitionTypeService,
    OTransitionTypeCategory,
    OPushSegmentType,
    OPushSegmentSelection
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      show: this.$route.query.show ?? '1',
      isManager: this.$store.state.user.authInfo === 'manager',
      idName: [],
      disableButton: false,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,
      isPublished: false, //公開中かどうかのフラグ
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      //お知らせデータ
      campaignData: {
        categoryId: '', // カテゴリID
        pushFlag: false, //push 通知フラグ
        text: '', //お知らせ内容
        title: '', //お知らせタイトル
        imageURL: '', //
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //優先フラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        draftFlag: false, //下書き
        checkStatus: '', //チェックステータス
        pushDoneCount: 0, //プッシュ通知総回数
        detailInfo: {
          //お知らせ詳細
          text: '',
          title: '',
          htmlContent: '',
          contentsURL: '',
          webviewFlag: false, //Webビューフラグ
          contentsFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          imageURL: '',
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          transitionType: 'url', //遷移先種別
          transitionDoc: '', //遷移先ドキュメントID
          dAccountLoginFlag: false, //ビジネスｄアカウントログイン
        },
        pushType: 'ALL',
        pushTargetListFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
        pushCategory: '',
        pushSegmentType: 'selection',
        pushSegmentSelectionInfo: {
          loginFlag: true,
          accountTypes: [],
          industries: [],
          employeeCounts: [],
        }
      },
      // CSVデータ
      pushTargetCsvList: [],

      isEnded: false,
      nowDate: '',
      updatedDataFlag: false,
      pushStatus: 'all',
      pushStatusOptions: [
        { value: 'all', label: '全体プッシュ通知' },
        { value: 'limited', label: '特定プッシュ通知' },
        { value: 'none', label: 'プッシュ通知なし' },
      ],
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-campaigns-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
    filteredTestSegmentCsvList() {
      // テスト特定配信用のCSV
      return this.pushTargetCsvList.filter(csv => csv.testPushFlag);
    },
    filteredSegmentCsvList() {
      // 特定配信のCSV
      return this.pushTargetCsvList.filter(csv => !csv.testPushFlag);
    },
  },
  created() {
    this.handleGetCampaignInfo(() => {
      const userRole = this.$store.state.user.authInfo;
      const checkStatus = this.campaignData.checkStatus;
      if (userRole === 'writer' && checkStatus !== 'draft') {
        this.disableButton = true;
      }
    });
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-campaigns-detail-' + i;
    }
  },
  methods: {
    handleGetCampaignInfo(callback) {
      const id = this.id;
      this.nowDate = utils.currentDateTime();
      if (id) {
        this.postRequest('/campaigns/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data && e.data.data) {
              const data = e.data.data;
              this.campaignData.pushFlag = data?.pushFlag || false;
              this.campaignData.categoryId = data?.categoryId || '';
              this.campaignData.title = data?.title || '';
              this.campaignData.text = data?.text || '';
              this.campaignData.imageURL = data?.imageURL || '';
              if (data?.pushDoneCount) {
                this.campaignData.pushDoneCount = data?.pushDoneCount;
              }
              (this.campaignData.imageFile = {
                file: data.imageURL ? data.imageURL : null,
              }),
                (this.campaignData.importantFlag = data?.importantFlag || false);
              this.campaignData.castStartDate = data?.castStartDate || '';
              this.campaignData.castEndDate = data?.castEndDate || '';
              this.campaignData.draftFlag = data?.draftFlag || false;
              this.campaignData.checkStatus = data?.checkStatus || '';
              this.campaignData.detailInfo.title = data?.detailInfo?.title || '';
              this.campaignData.detailInfo.text = data?.detailInfo?.text || '';
              if (data.detailInfo?.htmlContent) {
                this.campaignData.detailInfo.htmlContent = data?.detailInfo?.htmlContent;
              } else {
                // Note: 改行をpタグに統一してhtml化
                this.campaignData.detailInfo.htmlContent =
                  '<p>' + this.campaignData.detailInfo.text.replace(/\n/g, '</p><p>') + '</p>';
              }
              this.campaignData.detailInfo.contentsURL = decodeURI(data?.detailInfo?.contentsURL) || '';
              this.campaignData.detailInfo.webviewFlag = data?.detailInfo?.webviewFlag || false;
              this.campaignData.detailInfo.dAccountLoginFlag = data?.detailInfo?.dAccountLoginFlag || false;
              this.campaignData.detailInfo.imageURL = data?.detailInfo?.imageURL || '';
              this.campaignData.detailInfo.transitionType = data?.detailInfo?.transitionType || 'url';
              this.campaignData.detailInfo.transitionDoc = data?.detailInfo?.transitionDoc || '';
              (this.campaignData.detailInfo.imageFile = {
                file: data.detailInfo?.imageURL ? data.detailInfo.imageURL : null,
              }),
                (this.dataLoaded = true);
              // 下書きとチェク済み中ではなく、公開終了日時を過ぎている場合、isEndedフラグをtrueにする
              if (this.campaignData.checkStatus === 'approved') {
                if (this.campaignData.castEndDate && this.campaignData.castEndDate < this.nowDate) {
                  this.isEnded = true;
                }
              }
              this.campaignData.pushType = data?.pushType || 'ALL';
              this.campaignData.checkHistories = data?.checkHistories || [];
              // 通知ステータス設定
              if (this.campaignData.pushFlag === false) this.pushStatus = 'none';
              else if (this.campaignData.pushType === 'ALL') this.pushStatus = 'all';
              else this.pushStatus = 'limited';
              this.campaignData.pushCategory = data?.pushCategory || '';
              this.campaignData.pushSegmentType = data.pushSegmentType || 'selection';
              this.campaignData.pushSegmentSelectionInfo = buildPushSegmentSelectionForDisplay(this.pushStatus, data);

              const nowDate = utils.currentDateTime();
              // 公開中の投稿か確認
              if (
                data &&
                data.checkStatus === 'approved' &&
                data.castStartDate &&
                data.castEndDate &&
                data.castStartDate <= nowDate &&
                nowDate <= data.castEndDate
              ) {
                this.isPublished = true;
              }

              // CSVアップロード履歴
              if (e.data.pushTargetCsv) {
                this.pushTargetCsvList = Object.entries(e.data.pushTargetCsv).map(([key, value]) => {
                  value['id'] = key;
                  return value;
                });
                this.pushTargetCsvList.sort((a, b) => dayjs(b.updateDate).valueOf() - dayjs(a.updateDate).valueOf());
              }
            } else {
              this.showErrorModal(messageContent.requireTry('NEWS取得'));
            }
            if (typeof callback === 'function') {
              callback();
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('NEWS取得'));
          });
      }
    },
    async handleEditReturnUnpublished() {
      const data = {
        id: this.$route.query.id,
      };
      await this.postRequest('/campaigns/edit-return-unpublished', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'Campaigns' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('NEWS更新'));
          }
        }
      });
    },
    async handleEditKeepPublished() {
      const data = {
        id: this.$route.query.id,
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/campaigns/edit-keep-published', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'Campaigns' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('NEWS更新'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleNavigateEdit() {
      const id = this.$route.query.id;
      if (id) {
        this.$router.push({ name: 'CampaignsEdit', query: { id: id, source: 'detail', show: this.show } });
      }
    },
    handleConfirmDelete() {
      this.resultModalVisible = true;
      this.resultModalTitle = 'Info';
      this.resultModalContent = messageContent.confirmDelete(this.campaignData.title);
    },
    handleDelete() {
      this.handleCloseModal();
      const data = {
        execUserID: this.$store.state.user.userID,
        documentID: this.$route.query.id,
      };
      this.postRequest('/campaigns/delete', data).then(() => {
        this.$router.push({ name: 'Campaigns', query: { show: this.show } });
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'Campaigns', query: { show: this.show } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
